var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Portlet',{attrs:{"title":_vm.$t('mismatchedStateView.mismatchedStatesReport'),"icon":"thermometer-quarter"}},[_c('MismatchedStateReport')],1)}
var staticRenderFns = []

export { render, staticRenderFns }